<template>
    <div v-loading.fullscreen.lock="loading">
        
        <el-card shadow="always" :body-style="{ padding: '20px' }" style=" width: 500px; ">
            <div slot="header" style="text-align: left;">
                <span>Add</span>
            </div>
            <el-form :model="form" ref="formAdd" label-width="90px" :inline="false" :rules="rules" size="small">
                <el-form-item label="User" prop="user">
                        <el-autocomplete v-model="form.temp1" clearable :trigger-on-focus="false" @select="selectedUser" value-key="nama"
                            :debounce="800" :fetch-suggestions="querySearch" style="width: 380px;"></el-autocomplete>
                        
                </el-form-item>
                <el-form-item label="Client" prop="client">
                        <el-autocomplete v-model="form.temp2" clearable :trigger-on-focus="false" @select="selectedClient" value-key="nama"
                            :debounce="800" :fetch-suggestions="querySearch" style="width: 380px;"></el-autocomplete>
                </el-form-item>
                <el-form-item label="Package" prop="package" align="left">
                    <el-radio-group v-model="form.package">
                        <el-radio-button :label="item.id"  :key="index" v-for="(item, index) in packages">{{ item.name }}</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Type" prop="type" align="left">
                    <el-radio-group v-model="form.type">
                        <el-radio-button label="new">new</el-radio-button>
                        <el-radio-button label="renew">renew</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Amount" prop="amount" align="left">
                        <el-input v-model="form.amount" placeholder="" clearable style="width: 150px;"></el-input>
                </el-form-item>
                <el-form-item label="Date" prop="paymentdate" align="left">
                        <el-date-picker v-model="form.paymentdate" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="btnSimpan">Simpan</el-button>
                </el-form-item>
            </el-form>
            

            
        </el-card>
        
        <el-table :data="displayData"  stripe ref="tblSenarai" empty-text="Loading data.." @sort-change="sortChanges" style=" padding-top: 50px;">
            
            <el-table-column label="#" type="index" :index="pagination.page * pagination.pageSize - pagination.pageSize + 1" width="100"></el-table-column>
            <el-table-column prop="user" label="User" width="400"></el-table-column>
            <el-table-column prop="client" label="Client" width="400"></el-table-column>
            <el-table-column prop="package" label="Package" width="120"></el-table-column>
            <el-table-column prop="type" label="Type" width="130"></el-table-column>
            <el-table-column prop="amount" label="Amount" width="200">
                <template slot-scope="x">                    
                    RM {{ x.row.amount | formatMoney }}                  
                </template>
            </el-table-column>
            <el-table-column prop="paymentdate" label="Date" width="200">
                <template slot-scope="x">                    
                    {{ x.row.paymentdate | tarikh }}                  
                </template>
            </el-table-column>
            <el-table-column label="Tindakan" width="120">
                <template slot-scope="x">
                    
                    <el-button slot="reference" type="info" size="small" circle icon="el-icon-edit" style="margin-right: 10px;" @click="btnEdit(x.row.id)"></el-button>  
                    <el-popconfirm
                    confirm-button-text='Hapus'
                    cancel-button-text='Tidak'
                    icon="el-icon-info"
                    icon-color="red"
                    title="Anda pasti untuk hapus butiran tersebut?"
                    @confirm="btnHapus(x)"
                    >
                        <el-button slot="reference" type="danger" size="small" circle icon="el-icon-delete"></el-button>                                       
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentChange"
        :page-size="pagination.pageSize"
        :total="pagination.total">
        </el-pagination>
        
        <el-dialog
            title="Edit"
            :visible.sync="dlgKomisen.show"
            width="30%">
            <el-form :model="dlgKomisen.data" ref="formEdit" label-width="90px" :inline="false" :rules="rules" size="small">
                <el-form-item label="User" prop="user">
                        <el-autocomplete v-model="dlgKomisen.data.user" clearable :trigger-on-focus="false" @select="selectedUser" value-key="nama"
                            :debounce="800" :fetch-suggestions="querySearch" style="width: 380px;"></el-autocomplete>
                        
                </el-form-item>
                <el-form-item label="Client" prop="client">
                        <el-autocomplete v-model="dlgKomisen.data.client" clearable :trigger-on-focus="false" @select="selectedClient" value-key="nama"
                            :debounce="800" :fetch-suggestions="querySearch" style="width: 380px;"></el-autocomplete>
                </el-form-item>
                <el-form-item label="Package" prop="package" align="left">
                    <el-radio-group v-model="dlgKomisen.data.pid">
                        <el-radio-button :label="item.id"  :key="index" v-for="(item, index) in packages">{{ item.name }}</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Type" prop="type" align="left">
                    <el-radio-group v-model="dlgKomisen.data.type">
                        <el-radio-button label="new">new</el-radio-button>
                        <el-radio-button label="renew">renew</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Amount" prop="amount" align="left">
                        <el-input v-model="dlgKomisen.data.amount" placeholder="" clearable style="width: 150px;"></el-input>
                </el-form-item>
                <el-form-item label="Date" prop="paymentdate" align="left">
                        <el-date-picker v-model="dlgKomisen.data.paymentdate" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dlgKomisen.show = false">Cancel</el-button>
                <el-button type="primary" @click="updateKomisen">Update</el-button>
            </span>
        </el-dialog>
        
        
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
    name: 'Komisen',
    data() {
        return {   
            rules:{
                temp1: {
                    required: true,
                    message: "Sila pilih user"
                },
                
                temp2: {
                    required: true,
                    message: "Sila pilih client"
                },
                package: {
                    required: true,
                    message: "Sila pilih package anda"
                },
                type: {
                    required: true,
                    message: "Sila pilih type"
                },
                amount: {
                    required: true,
                    message: "Masukkan jumlah amaun komisen dalam format decimal",
                    pattern: /^[0-9]*\.[0-9]{2}$/
                },
                paymentdate: {
                    required: true,
                    message: "Sila pilih tarikh"
                },
            },
            senarai: [],
            packages: [],
            form: {},
            loading: false,
            sort: {
                prop: 'paymentdate',
                order: 'descending'
            },
            dlgKomisen: {
                show: false,
                data: {}
            },
            pagination: {
                pageSize: 25,
                page: 1,
                total: 0
            }
        }
    },
    computed: {
        isAdmin: function() {
            return this.$store.getters.isAdmin
        },
        displayData() {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.pagination.total = this.senarai.length
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            let data =  this.senarai.sort((a,b) => {
                let _this = this
                if(this.sort.order == 'descending') {
                    return a[_this.sort.prop] < b[_this.sort.prop] ? -1 : (a[_this.sort.prop] > b[_this.sort.prop]) ? 1 : 0
                }
                else {
                    return a[_this.sort.prop] > b[_this.sort.prop] ? -1 : (a[_this.sort.prop] < b[_this.sort.prop]) ? 1 : 0
                }
            })
            

            return data.slice(this.pagination.pageSize * this.pagination.page - this.pagination.pageSize, this.pagination.pageSize * this.pagination.page);
        }
    },
    methods: {
        selectedUser(item) {    
            if(this.dlgKomisen.show) {
                this.dlgKomisen.data.uid = item.value
            }
            else {
                this.form.user = item.value
            }
        },
        selectedClient(item) {
            if(this.dlgKomisen.show) {
                this.dlgKomisen.data.cid = item.value
            }
            else {   
                this.form.client = item.value
            }
        },
        querySearch(query, cb) {
            let results = query ? this.users.filter( f => f.nama.toLowerCase().indexOf(query.toLowerCase()) >= 0 ) : this.users;
            cb(results)
        },
        getData() {
            axios('commission')
            .then( resp => {
                this.senarai = resp.data.commissions
                this.users = resp.data.users
                this.packages = resp.data.packages
                this.loading = false
            })
            .catch( () => {
                this.$store.dispatch('LogOut');
                this.$router.push('login')
                this.loading = false
            })
        },
        btnSimpan() {
            
            this.$refs['formAdd'].validate((valid) => {
                if (valid) {
                    try {
                        this.loading = true
                        axios.post('commission', this.form)
                        .then( resp => {    
                            this.loading = false                                      
                            this.$message({
                                message: resp.data.message,
                                type: resp.data.status
                            });
                            this.getData();
                        })
                    } catch (error) {
                        console.log(error);
                    }
                }
            })
        },
        btnHapus(x) {
            // this.senarai.splice(x.$index, 1)
            this.senarai.splice(this.senarai.findIndex( s => s.id == x.row.id), 1)
            axios.delete('commission', { data: {id : x.row.id }})
            .then(() => {
                                       
                this.$message({
                    message: 'Rekod komisen tersebut telah dihapuskan',
                    type: 'success'
                });

            })
            .catch(err => {
                console.log(err);
            })
            
        },
        updateKomisen() {
            this.loading = true
            console.log(this.dlgKomisen.data);
            axios.put('commission', this.dlgKomisen.data)
            .then( resp => {                
                this.loading = false                                      
                this.$message({
                    message: resp.data.message,
                    type: resp.data.status,
                });
                this.getData();
                this.dlgKomisen.show = false
            })
        },
        btnEdit(id) {
            this.dlgKomisen.show = true
            this.dlgKomisen.data = { ...this.senarai.find( f => f.id === id)}
            this.dlgKomisen.data.amount = Number(this.dlgKomisen.data.amount).toFixed(2)
        },
        currentChange(val) {
            this.pagination.page = val
        },
        sortChanges({ prop, order }) {
            this.sort = { prop, order }
        }
    },
    created() {   
        if(!this.isAdmin) {
            this.$router.push('/')
        }

        this.loading = true
        this.getData()
        
    },
    filters: {
        tarikh(x) {
            return moment(x,'yyyy-MM-DD hh:mm:ss').format('DD/MM/yyyy')
        },
        formatMoney (v) {
            return v == null ? '0.00' : parseFloat(v).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');  // 12,345.67
        }

    }
}
</script>
